import React from 'react'
import { Button, Modal, NavBar } from 'antd-mobile-v5'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useCancelAgreements, useMainlandIp } from '../../services/hooks'
import { useLanguage } from '../../services/hooks/user'
import { removePadiWxId } from '../../components/common/cookie'
import { CLUB_URL_DOMAIN } from '../../utils/env'
import { isTaiwanUser } from '../../utils/user'
import style from './UserAgreement.module.css'

const UserAgreement = () => {
  const { replace, goBack } = useHistory()
  const { data: isMainlandIp } = useMainlandIp({})
  const lang = useLanguage()
  const { run: cancel, loading } = useCancelAgreements({
    onSuccess: (data) => {
      if (data) {
        removePadiWxId()
        if (window.location.href.indexOf('from') > 0) {
          window.location.replace(CLUB_URL_DOMAIN)
        } else {
          replace('/emailLogin')
        }
      }
    },
  })

  const handleRevoke = async () => {
    const result = await Modal.confirm({
      content:
        '您选择拒绝网站使用的隐私设置以及用户协议，如果继续我们将再次与您联系确认后删除相关数据，您将无法使用本网站的服务。',
      confirmText: '继续',
    })
    if (result) {
      cancel()
    }
  }

  const clickGoBack = () => {
    if (window.location.href.indexOf('from') > 0) {
      window.location.replace(CLUB_URL_DOMAIN)
    } else {
      goBack()
    }
  }

  return (
    <div className={style.wrapper}>
      <NavBar style={{ background: 'rgb(248, 248, 248)', color: '#333333', fontWeight: 'bold' }} back={null}>
        隐私与用户协议
      </NavBar>
      <div className={style.content}>
        <div>注册并使用本网站即表示您已同意以下隐私与用户协议：</div>
        <div className={style.agreements}>
          {isMainlandIp && (
            <>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://assets.padi.com.cn/agreements/club-user-agreement.html"
              >
                PADI Club会员协议
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`https://assets.padi.com.cn/personalInfo_agreement_${lang}.html`}
              >
                <FormattedMessage id="common-info-agreement" />
              </a>
            </>
          )}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={
              isTaiwanUser()
                ? 'https://www.padi.com.tw/zh-hant/privacy'
                : `https://assets.padi.com.cn/agreement_${lang}.html`
            }
          >
            <FormattedMessage id="common-agreement" />
          </a>
        </div>
        <Button block color="primary" onClick={handleRevoke} loading={loading}>
          撤销统一协议
        </Button>
        <Button color="primary" fill="none" onClick={clickGoBack}>
          返回
        </Button>
      </div>
    </div>
  )
}

export default UserAgreement
